import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useContext } from "react";
import { FormContext } from "../Muiltiforms";
import * as yup from "yup";
import FormikControl from '../../../../hoc/formikComponents/FormikControl.js'

function Success() {
  const { activeStepIndex, setActiveStepIndex, formData, setFormData } =
    useContext(FormContext);

  const renderError = (message) => (
    <p className="italic text-red-600">{message}</p>
  );

  const ValidationSchema = yup.object().shape({
    name: yup.string().required(),
    email: yup.string().email().required(),
  });

  return (
    
          <div><p>hello</p></div>
        
);
}

export default Success;